export default __webpack_public_path__ + "static/media/equipar_item_03.bf5b62b0.mp3";